export default __webpack_public_path__ + "static/mstile-310x310-3abf66cf113d4a397190e3309716f3c5.png";